export default __webpack_public_path__ + "media/components/AdEdit/images/vk-share-70c89a34d50fbfa1dbc430b88e16a58d.svg";